import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { LOCATIONS } from '../../constants/locations';
import { contentApi } from '../../services/contentApi';
import { getDlCaseTypeLabel } from '../../constants/driver';
import { contentKeys } from '../../constants/contentKeys';

const formatDate = (dateStr: string) => {
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const months = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
  return `${d}. ${months[m - 1]} ${y}`;
};

const DriverSummaryStep: React.FC = () => {
  const { selfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi.getByKey(contentKeys.koerekort.dl_summary).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  return (
    <StepContainer title="Gennemgå din ansøgning">
      {body && (
        <InfoBox type="info">
          {body.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </InfoBox>
      )}
      <ul className="summary-list">
        <li>
          <span className="label">Ansøgningstype</span>
          <span className="value">{getDlCaseTypeLabel(selfServiceData.dlCaseType)}</span>
        </li>
        {selfServiceData.dlCategory && (
          <li>
            <span className="label">Kørekortkategori</span>
            <span className="value">{selfServiceData.dlCategory}</span>
          </li>
        )}
        {selfServiceData.dlHasMedicalDoc && (
          <li>
            <span className="label">Lægeattest</span>
            <span className="value">Medbringes</span>
          </li>
        )}
        {selfServiceData.dlHasVisionDoc && (
          <li>
            <span className="label">Synstest</span>
            <span className="value">Medbringes</span>
          </li>
        )}
        {typeof selfServiceData.dlUnder18 === 'boolean' && (
          <li>
            <span className="label">Under 18 år</span>
            <span className="value">{selfServiceData.dlUnder18 ? 'Ja' : 'Nej'}</span>
          </li>
        )}
        {selfServiceData.dlUnder18 && selfServiceData.dlParentConsentRequested && (
          <>
            {(selfServiceData.dlGuardian1Name || selfServiceData.dlGuardian1Email) && (
              <li>
                <span className="label">Forælder 1</span>
                <span className="value">
                  {`${selfServiceData.dlGuardian1Name || ''}${selfServiceData.dlGuardian1Email ? ` (${selfServiceData.dlGuardian1Email})` : ''}`}
                </span>
              </li>
            )}
            {(selfServiceData.dlGuardian2Name || selfServiceData.dlGuardian2Email) && (
              <li>
                <span className="label">Forælder 2</span>
                <span className="value">
                  {`${selfServiceData.dlGuardian2Name || ''}${selfServiceData.dlGuardian2Email ? ` (${selfServiceData.dlGuardian2Email})` : ''}`}
                </span>
              </li>
            )}
            {selfServiceData.dlNotifySecondGuardian && (
              <li>
                <span className="label">Digital Post</span>
                <span className="value">Informerer forælder 2 via Digital Post</span>
              </li>
            )}
          </>
        )}
        <li>
          <span className="label">Borgerservice</span>
          <span className="value">{selfServiceData.location ? LOCATIONS[selfServiceData.location] : ''}</span>
        </li>
        <li>
          <span className="label">Dato</span>
          <span className="value">{selfServiceData.date ? formatDate(selfServiceData.date) : ''}</span>
        </li>
        <li>
          <span className="label">Tid</span>
          <span className="value">{selfServiceData.time ? `kl. ${selfServiceData.time}` : ''}</span>
        </li>
      </ul>
      <NavigationButtons onBack={goBack} onNext={goNext} />
    </StepContainer>
  );
};

export default DriverSummaryStep;
